import { NavLink, Navigate, Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { NAV_ICONS, IconLogout, IconFile } from "../../ui/icons";
import { logoutFetch } from "../../../store/authSlice";
import { getLoginPath } from "../../../utils/authRedirect";
import { normalizeRole, isClubOwner } from "../../../utils/roles";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import { useIsMobile } from "../../../hooks/useMediaQuery";
import {
  CRM_USER_GUIDE_HINT,
  CRM_USER_GUIDE_LABEL,
  CRM_USER_GUIDE_URL,
} from "../../../constants/crmGuide";
import {
  ADMIN_SETTINGS_NAV,
  buildAdminSidebarNav,
  resolveAdminTabId,
} from "../../../utils/adminNav";
import s from "./adminApp.module.css";
import { Avatar } from "../../ui";

const ROLE_LABEL = {
  owner: "Владелец",
  admin: "Администратор",
};

export default function AdminAppMore() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useIsMobile(768);
  const { pathname } = useLocation();
  const { profile, role, club, tenant, billing, entitlements } = useSelector(
    (state) => state.auth,
  );
  const nav = buildAdminSidebarNav(club, tenant, { billing, entitlements, role });
  const activeTab = resolveAdminTabId(pathname);

  const photoSrc = mediaUrl(profile?.photo_url);
  const owner = isClubOwner({ role, profileRole: profile?.role, club });
  const profileTo = owner ? "/manage/app/profile" : "/manage/app/settings";

  const logout = () => {
    dispatch(logoutFetch());
    navigate(getLoginPath(role));
  };

  const renderLink = (item) => {
    const Icon = NAV_ICONS[item.icon] || NAV_ICONS.overview;
    const active = activeTab === item.id;
    return (
      <NavLink
        key={item.id}
        to={item.to}
        end={item.end}
        className={active ? `${s.moreListItem} ${s.moreListItemActive}` : s.moreListItem}
      >
        <span className={s.moreListIconWrap}>
          <Icon className={s.moreListIcon} />
        </span>
        <span className={s.moreListLabel}>{item.label}</span>
        <span className={s.moreListChevron} aria-hidden />
      </NavLink>
    );
  };

  if (!isMobile) {
    return <Navigate to="/manage/app" replace />;
  }

  return (
    <>
      <header className={s.moreHubHead}>
        <h1 className={s.moreHubTitle}>Ещё</h1>
      </header>
      <div className={s.morePage}>
        <Link to={profileTo} className={s.moreProfile}>
          <Avatar
            name={profile?.full_name || "?"}
            src={photoSrc}
            size="md"
            className={s.moreAvatarImg}
          />
          <div className={s.moreProfileInfo}>
            <p className={s.moreProfileName}>{profile?.full_name || "—"}</p>
            <p className={s.moreProfileRole}>
              {owner
                ? `${ROLE_LABEL.owner} · Профиль`
                : `${ROLE_LABEL[normalizeRole(role)] || ROLE_LABEL.admin} · Настройки`}
            </p>
          </div>
          <span className={s.moreProfileChevron} aria-hidden />
        </Link>

        <section>
          <h2 className={s.moreSectionTitle}>Разделы</h2>
          <div className={s.moreListGroup}>{nav.more.map(renderLink)}</div>
        </section>

        <section>
          <h2 className={s.moreSectionTitle}>Клуб</h2>
          <div className={s.moreListGroup}>
            {renderLink(ADMIN_SETTINGS_NAV)}
            <a
              href={CRM_USER_GUIDE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={s.moreListItem}
            >
              <span className={s.moreListIconWrap}>
                <IconFile className={s.moreListIcon} />
              </span>
              <span className={s.moreListLabel}>
                {CRM_USER_GUIDE_LABEL}
                <span className={s.moreListHint}>{CRM_USER_GUIDE_HINT}</span>
              </span>
              <span className={s.moreListChevron} aria-hidden />
            </a>
          </div>
        </section>

        <button type="button" className={s.moreLogout} onClick={logout}>
          <IconLogout width={18} height={18} />
          Выйти
        </button>
      </div>
    </>
  );
}
